import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    gaugeChartKeyDialogVisible: false,
    nestedPieChartKeyDialogVisible: false
}

export const tooltipsSlice = createSlice({
    name: 'tooltips',
    initialState,
    reducers: {
        toggleGaugeChartKeyDialog: (state) => {
            const visible = !state.gaugeChartKeyDialogVisible;
            state.gaugeChartKeyDialogVisible = visible;
            if (visible) {
                state.nestedPieChartKeyDialogVisible = false;
            }
        },
        showGaugeChartKeyDialog: (state) => {
            state.gaugeChartKeyDialogVisible = true;
            state.nestedPieChartKeyDialogVisible = false;
        },
        hideGaugeChartKeyDialog: (state) => {
            state.gaugeChartKeyDialogVisible = false;
        },
        toggleNestedPieChartKeyDialog: (state) => {
            const visible = !state.nestedPieChartKeyDialogVisible;
            state.nestedPieChartKeyDialogVisible = visible;
            if (visible) {
                state.gaugeChartKeyDialogVisible = false;
            }
        },
        showNestedPieChartKeyDialog: (state) => {
            state.nestedPieChartKeyDialogVisible = true;
            state.gaugeChartKeyDialogVisible = false;
        },
        hideNestedPieChartKeyDialog: (state) => {
            state.nestedPieChartKeyDialogVisible = false;
        },
        hideChartKeyDialogs: (state) => {
            state.gaugeChartKeyDialogVisible = false;
            state.nestedPieChartKeyDialogVisible = false;
        },
    }
});

export const { toggleGaugeChartKeyDialog, showGaugeChartKeyDialog, hideGaugeChartKeyDialog, toggleNestedPieChartKeyDialog, showNestedPieChartKeyDialog, hideNestedPieChartKeyDialog, hideChartKeyDialogs } = tooltipsSlice.actions;
export const selectGaugeChartKeyDialogVisible = (state) => (state.tooltips.gaugeChartKeyDialogVisible === true);
export const selectNestedPieChartKeyDialogVisible = (state) => (state.tooltips.nestedPieChartKeyDialogVisible === true);

export default tooltipsSlice.reducer;


